import React, { useEffect, useState } from 'react'
import { InputCompo } from '../../../Components/InputCompo/InputCompo'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import CustomInput from '../../../Components/InputCompo/CustomInput'
import * as Yup from 'yup';
import { useFormik } from 'formik';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import ButtonComp from '../../../Components/ButtonComp/ButtonComp';
import { useMutation, useQuery } from '@tanstack/react-query';
import { EOIGet, ExpressionOfInterestRegistration } from '../../../Store/auth/register';
import { enqueueSnackbar } from 'notistack';
import FinancialYearForm from './FinancialYear';

const CertificationInterestFinancialReadiness = ({setSubTabs}) => {
  const [initialValues, setInitialValues] = useState({});

    const gsnNoFromStorage =localStorage.getItem('gsn_no');    
    
    const { data: questions } = useQuery({
        queryKey: 'EOI',
        queryFn: () => EOIGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
    });

    const options = Array.from({ length: 225 }, (_, i) => ({ option: (1800 + i).toString() }));
    const option1 = Array.from({ length: 51 }, (_, i) => {
                      const startYear = 2000 + i;
                      const endYear = startYear + 1;
                      return { option: `${startYear}-${endYear.toString().slice(-2)}` };
                    });

  const [financialYearsData, setFinancialYearsData] = useState([]);

  // Function to update financialYears in the parent component
  const handleFinancialYearsChange = (data) => {
    setFinancialYearsData(data);
  };

  

  const documents = [
    {
      type: 'dropdown', 
      question_no: 'know_about_gsi', 
      question: 'How did you come to know about GuideStar India certification?', 
      description: '', 
      depend_question: '', 
      condition: 'equals', 
      value: 'yes', 
      validation:'dropdown', 
      options: [{"option": "Email from GuideStar India","value": null,"explanation": null},{"option": "GuideStar India workshop","value": null,"explanation": null},{"option": "Other","value": null,"explanation": null}]
      , 
      mandatory: 1,
    },
    {
      type: 'text', 
      question_no: 'other1', 
      question: 'Other (Please Specify)', 
      description: '', 
      depend_question: 'know_about_gsi',
      condition: 'equals', 
      value: 'yes', 
      validation:'text', 
      options: [],
      mandatory: 0,
    },
    {
      type: 'dropdown', 
      question_no: 'financial_year', 
      question: 'Financial Year', 
      description: '', 
      depend_question: 'field2',
      condition: 'equals', 
      value: 'yes',
      validation:'dropdown', 
      options: option1,
      mandatory: 1,
    },
    {
      type: 'text', 
      question_no: 'annual_expenditure', 
      question: 'Please provide your approximate Annual Expenditure for financial year under review', 
      description: '(Please enter Rs. in Lac)', 
      depend_question: 'field3',
      condition: 'equals', 
      value: 'yes', 
      validation:'number',
      options: [],
      mandatory: 1,
    },
    {
      type: 'textsss', 
      question_no: 'specify_entity_name', 
      question: 'Entity Name*', 
      description: '', 
      depend_question: '',
      condition: 'equals', 
      value: 'yes', 
      validation:'text',
      options: [],
      mandatory: 1,
    },
    {
      type: 'dropdown', 
      question_no: 'year_of_registration', 
      question: 'Year of Registration', 
      description: '', 
      depend_question: 'field4',
      condition: 'equals', 
      value: 'yes', 
      validation:'dropdown',
      options: options,
      mandatory: 1,
    },
    {
      type: 'dropdown', 
      question_no: 'valid_12a_reg', 
      question: 'Does your organisation have a valid 12 A registration under Income Tax act', 
      description: '', 
      depend_question: 'field5',
      condition: 'equals', 
      value: 'yes', 
      validation:'dropdown',
      options: [{"option": "Yes"},{"option": "No"}],
      mandatory: 1,
    },
    {
      type: 'dropdown', 
      question_no: 'apply_certification', 
      question: 'Are you applying for certification to meet the requirements of any particular funder/platform/campaign/awards, etc.?', 
      description: '', 
      depend_question: 'field5',
      condition: 'equals', 
      value: 'yes', 
      validation:'dropdown',
      options: [{"option": "Yes"},{"option": "No"}],
      mandatory: 1,
    },
    {
      type: 'text', 
      question_no: 'specify_entity_name', 
      question: 'Certification Entity Name', 
      description: 'If yes, please share the name of the entity. This will help us guide you on the aspects that you should prioritize.', 
      depend_question: 'apply_certification',
      condition: 'equals', 
      value: 'yes', 
      validation:'text',
      options: [],
      mandatory: 0,
    },
    {
      type: 'date', 
      question_no: 'certification_date', 
      question: 'Certification Results Deadline', 
      description: 'If you need the certification results by any particular date, please provide that date. This will help us schedule your application process effectively.', 
      depend_question: '',
      condition: 'equals', 
      value: 'yes', 
      validation:'date',
      options: [],
      mandatory: 0,
    },
    
    
  ];


  
  const checkBoxData = [
    {
      label: 'Transparency & Accountability',
      name: 'transparency',
    },
    {
      label: 'Donor Requirement',
      name: 'donor_requirement',
    },
    {
      label: 'Credibility',
      name: 'credibility',
    },
    {
      label: 'Fundraising',
      name: 'fundraising_donor',
    },
    {
      label: 'Visibility',
      name: 'visibility',
    },
    {
      label: 'CSR',
      name: 'csr_corporate',
    },
    {
      label: 'Organization Development',
      name: 'organisation_development',
    },
    {
      label: 'Other (Please Specify)',
      name: 'other',
      isCustomInput: true,
      mandatory: 0,
    },
  ];

  const modelSchema = Yup.object().shape(
    documents.reduce((schema, field) => {
        if (field.mandatory === 1 && field.type.toLowerCase() !== 'section') {
            let validator = Yup.string().required(`${field.question} is required`);

            if (field.validation) {
              switch (field.validation.toLowerCase()) {
                  case 'email':
                      validator = Yup.string()
                          .email('Invalid email address')
                          .required(`${field.question} is required`);
                      break;
                  case 'number':
                        validator = Yup.number()
                          .integer("Must be an number")
                          .positive("Must be a positive number")
                          .required(`Must be an number`);
                        break;
                  case 'pan':
                      validator = Yup.string()
                          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN Number. It should be in the format: ABCDE1234F.')
                          .required(`${field.question} is required`);
                      break;
                  case 'pincode':
                      validator = Yup.string()
                          .matches(/^\d{4}$|^\d{6}$/, 'PIN code must be exactly 6 digits')
                          .required(`${field.question} is required`);
                      break;
                  case 'areacode':
                      validator = Yup.string()
                          .matches(/^(123|456|789)$/, 'Incorrect area code')
                          .required(`${field.question} is required`);
                      break;
                  case 'website':
                      validator = Yup.string()
                          .url('Please enter a valid URL')
                          .required(`${field.question} is required`);
                      break;
                  case 'mobile':
                      validator = Yup.string()
                          .matches(/^(?:[0-9]{10}|[0-9]{7})$/, 'Invalid contact number')
                          .required(`${field.question} is required`);
                      break;
                  case 'darpan':
                      validator = Yup.string()
                          .test(
                              'is-valid-darpan',
                              'Darpan Id should be in the format: XX/1234/1234567',
                              (value) => value?.toUpperCase() === 'NA' || /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
                          )
                          .required(`${field.question} is required`);
                      break;
                  case 'password':
                      validator = Yup.string()
                          .min(8, 'Password must be at least 8 characters long')
                          .required(`${field.question} is required`);
                      break;
                  case 'multiselect dropdown':
                      validator = Yup.array().required(`${field.question} is required`);
                      break;
                  case 'attach':
                      validator = Yup.object().required(`${field.question} is required`);
                      break;
                  default:
                      validator = Yup.string().required(`${field.question} is required`);
                      break;
              }
          }
          

            schema[field.question_no] = validator;
        }

        return schema;
      }, {})
    );

    useEffect(() => {
      const savedData = JSON.parse(localStorage.getItem('formData')) || {};
  
      if (questions?.documents) {
          const apiData = questions.documents;
  
          // Initialize form values with the data from `documents` and `checkBoxData`
          const formValues = {
              // Reduce over `documents` to get the values
              ...documents.reduce((acc, field) => {
                  acc[field.question_no] = apiData[field.question_no] || savedData[field.question_no] || '';
                  return acc;
              }, {}),
  
              // Reduce over `checkBoxData` to get checkbox values
              ...checkBoxData.reduce((acc, checkbox) => {
                  if (checkbox.isCustomInput) {
                      // For checkboxes with associated input fields, get the input value
                      acc[checkbox.name] = apiData[checkbox.name] || savedData[checkbox.name] || '';
                  } else {
                      // For normal checkboxes, default to `false` if no data exists
                      acc[checkbox.name] = apiData[checkbox.name] || savedData[checkbox.name] || false;
                  }
                  return acc;
              }, {})
          };
  
          setInitialValues(formValues); // Set initial values with merged data from API and localStorage
      } else {
          // If API data is unavailable, only use the localStorage data
          const formValues = {
              // Reduce over `documents` to get the values from localStorage
              ...documents.reduce((acc, field) => {
                  acc[field.question_no] = savedData[field.question_no] || '';
                  return acc;
              }, {}),
  
              // Reduce over `checkBoxData` to get checkbox values from localStorage
              ...checkBoxData.reduce((acc, checkbox) => {
                  if (checkbox.isCustomInput) {
                      // For checkboxes with associated input fields, get the input value
                      acc[checkbox.name] = savedData[checkbox.name] || '';
                  } else {
                      // For normal checkboxes, default to `false`
                      acc[checkbox.name] = savedData[checkbox.name] || false;
                  }
                  return acc;
              }, {})
          };
  
          setInitialValues(formValues); // Set initial values from localStorage only
      }
  }, [questions]);
  

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: modelSchema,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting }) => {
          try {
            // Convert the form data into a flat object
            const tempData = {
                ...documents.reduce((acc, field) => {
                    acc[field.question_no] = values[field.question_no];
                    return acc;
                }, {}),
                ...checkBoxData.reduce((acc, checkbox) => {
                  if (checkbox.isCustomInput) {
                      // If the checkbox has an associated input field, save the input field's value
                      acc[checkbox.name] = values[checkbox.name];
                  } else {
                      // For normal checkboxes, save "Yes" or "No"
                      acc[checkbox.name] = values[checkbox.name] ? 1 : 0;
                  }
                  return acc;
                }, {}),
            };
        
            // Retrieve existing data from localStorage
            const existingData = JSON.parse(localStorage.getItem('formData')) || {};
        
            // Merge new data with existing data
            const updatedData = {
                ...existingData,
                ...tempData,
                audited_accounts: financialYearsData,
            };

            // Save updated data to localStorage
            localStorage.setItem('formData', JSON.stringify(updatedData));
                        
            setSubTabs({'Additional Information and Undertakings': true });
            // await submitReg(structuredData);

          } catch (error) {
              // console.error(error);
          } finally {
              setSubmitting(false);
          }
        },
    });


    
  return (
    <>
      <form className='flex flex-col gap-[30px] ' action="" onSubmit={formik.handleSubmit}>
        
        <div className=''>
          <ParagraphComp className='font-bold text-lg' text='Please let us know why you would like to undergo certification' />
        </div>

        <div className='w-[100%] flex gap-[24pt] flex-wrap'>
        
            {checkBoxData.map((item, index) => (
            <div className='w-[35%] flex gap-[24pt]' key={index}>
              {!item.isCustomInput?
              <div className='w-[100%]'>
                <label className="flex items-center space-x-2">
                  <InputCompo 
                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                    type='checkbox' 
                    name={item.name}
                    checked={formik.values[item.name]} 
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur} 
                  />
                  <span className='text-black'>{item.label}</span>
                </label>
                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
              </div>
                :<>
                {item.isCustomInput && (
                  <div className='w-[100%]'>
                    <label className="flex items-center space-x-2">
                    <InputCompo 
                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                    type='checkbox' 
                    name={item.name}
                    checked={formik.values[item.name]} 
                    onChange={formik.handleChange} 
                    onBlur={formik.handleBlur} 
                  />
                      <CustomInput 
                         
                        {...formik.getFieldProps(item.name)} 
                        name={item.name} 
                        label={item.label} 
                        onBlur={formik.handleBlur} 
                      />
                    </label>
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
                  </div>
                )}</>}
            </div>
          ))}
        </div>

        {/* <div className=''>
          <ParagraphComp className='font-bold text-lg' text='Awareness of GuideStar India' />
        </div> */}
        
        <div className='flex flex-wrap gap-[30px] justify-between w-[100%]'>
        
            {documents.slice(0 , 2).map(Fields => (
              <>
                {Fields.type.toLowerCase() === 'dropdown' ? (
                  <div className='w-[100%]' key={Fields.question_no}>
                    <CustomSelection 
                      required 
                      options={Fields?.options}
                      {...formik?.getFieldProps(Fields?.question_no)}
                      name={Fields.question_no} 
                      label={Fields.question}
                    />
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />

                    {/* Check if 'Other' is selected, then display the text input */}
                    { formik.values.know_about_gsi === 'Other' && (
                      <div className='w-[100%]'>
                      {/* Render the 'Other (Please Specify)' text input */}
                      {documents.find(doc => doc.question_no === 'other1') && (
                        <CustomInput
                          required={false}
                          {...formik.getFieldProps('other1')}  
                          name="other1"
                          label="Other (Please Specify)"
                          onBlur={formik.handleBlur}
                        />
                      )}
                    </div>
                    )}
                  </div>
                ) : null}
              </>
            ))}
            {/* <div className=''>
              <ParagraphComp className='font-bold text-lg' text='Financial Readiness' />
            </div> */}
            <div className='w-[100%]'>
              <FinancialYearForm onFinancialYearsChange={handleFinancialYearsChange}/>
            </div>

            {documents.slice(2, 5).map(Fields =>
            <>
              {Fields.type.toLowerCase() === 'text' || Fields.type.toLowerCase() === 'number' || Fields.type.toLowerCase() === 'date' ?
                <div className='w-[100%]'>
                    <CustomInput 
                        required
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no} label={Fields.question}
                        onBlur={formik.handleBlur}  
                    />
                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                    <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                </div>
                :
                Fields.type.toLowerCase() === 'dropdown'
                    ?
                    <div className='w-[100%]'>
                        <>
                            <CustomSelection required options={Fields?.options}
                                {...formik?.getFieldProps(Fields?.question_no)}
                                name={Fields.question_no} label={Fields.question}
                            />
                            {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                    </div>
                    :''
                }
            </>
            )}
            {documents.slice(5, 10).map(Fields =>
            <>
              
                {Fields.type.toLowerCase() === 'dropdown'
                    ?
                    <div className='w-full'>
                        <>
                            <CustomSelection required options={Fields?.options}
                                {...formik?.getFieldProps(Fields?.question_no)}
                                name={Fields.question_no} label={Fields.question}
                            />
                            {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                            <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                    </div>
                    :Fields.type.toLowerCase() === 'date' ? (
                      <div className='w-[100%]'>
                        <CustomInput 
                          required={Fields.mandatory === 1}
                          {...formik.getFieldProps(Fields.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                          onBlur={formik.handleBlur}  
                          type={Fields.type}
                          disabled={true}
                        />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                      </div>
                      )
                    :''
                }
                {formik.values?.apply_certification === 'Yes' && Fields.depend_question === 'apply_certification' && (
                <>
                  {Fields.type.toLowerCase() === 'text'  && (
                    <div className='w-[100%]'>
                      <CustomInput 
                        required={Fields.mandatory === 1}
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        onBlur={formik.handleBlur}  
                      />
                      <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                      <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                    </div>
                  )}
                  {Fields.type.toLowerCase() === 'date' && (
                    <div className='w-[100%]'>
                      <CustomInput 
                        required={Fields.mandatory === 1}
                        {...formik.getFieldProps(Fields.question_no)}
                        name={Fields.question_no}
                        label={Fields.question}
                        onBlur={formik.handleBlur}  
                        type={Fields.type}
                        disabled={true}
                      />
                      <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.values?.[Fields.question_no] && formik.errors?.[Fields.question_no]} />
                      <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />
                    </div>
                  )}
                </>
              )}
            </>
            )}             
          </div >
          
          <div className='flex justify-end'>
              <div className='flex gap-[20px]'>
                  {/* <ButtonComp text={'Save'} className='px-[20px] rounded-full border-1 border-[#004878] text-[#004878] py-[10px]' /> */}
                  <ButtonComp text={'Save & Next'} type={'submit'} className='px-[20px] rounded-full bg-[#004878] text-[white] py-[10px]' />
              </div>
          </div>
      </form>
    </>
  )
}

export default CertificationInterestFinancialReadiness
